import type { InductionBasis, PolicyAudience, RecordStatus } from '../../types/induction';

export const BASIS_LABELS: Record<InductionBasis, string> = {
  assessed: 'Assessed',
  supervisor_override: 'Supervisor override',
  prior_competency: 'Existing operator — recognised',
};

/** The short hint shown inside a register cell. Assessed is the normal case and says nothing. */
export const BASIS_HINTS: Record<InductionBasis, string | null> = {
  assessed: null,
  supervisor_override: 'override',
  prior_competency: 'prior',
};

export const STATUS_LABELS: Record<RecordStatus, string> = {
  current: 'Current',
  expiring: 'Expiring',
  expired: 'Expired',
  revoked: 'Revoked',
};

export const STATUS_CLASSES: Record<RecordStatus, string> = {
  current: 'bg-success-50 text-success-700 border-success-200',
  expiring: 'bg-warning-50 text-warning-800 border-warning-200',
  expired: 'bg-error-50 text-error-700 border-error-200',
  revoked: 'bg-neutral-100 text-neutral-600 border-neutral-200',
};

export const WORKER_TYPES: Record<string, string> = {
  employee: 'Employee',
  casual: 'Casual',
  contractor_worker: 'Contractor',
};

export const personLabel = (name: string | null | undefined) => name || 'Unnamed person';

const AUDIENCE_TYPE: Record<PolicyAudience, string | null> = {
  everyone: null,
  employees: 'employee',
  casuals: 'casual',
  contractors: 'contractor_worker',
};

export function packApplies(audience: PolicyAudience, workerType: string): boolean {
  const t = AUDIENCE_TYPE[audience];
  return t === null || t === workerType;
}

